<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>تقرير الشمع المطلوب</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض تقرير الشمع المطلوب
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class="col-lg-10 col-md-9 col-sm-12">
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <label>الفرع</label>
                  <select  @change='FillItineraries()' class="form-control" style="padding:0px" v-model="brancheID">
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <label>المنطقة:</label>
                  <select class="form-control" style="padding: 0px" v-model="region_id">
                    <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.region_name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <label>&nbsp;</label>
                  <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                    <b> عرض </b>
                  </button>
                </div>
              </div>
              <div class="col-lg-2 col-md-3 col-sm-12" style="padding: 0px">
                <!-- /.panel -->
                <div class="chat-panel panel panel-default" >
                  <div class="panel-heading">
                    الخطوط
                  </div>
                  <!-- /.panel-heading -->
                  <div class="panel-body" style="padding: 5px">
                    <div v-for="(item,index) in lines" v-bind:key="index" >
                      <input @click="FillRegions($event)" :id="index" type="checkbox" :value="item.id" v-model="selectedLine">{{' ' + item.name }}
                    </div>
                  </div>
                  <!-- /.panel-body -->
                </div>
              </div>
              <!--
              <div>
                <button type="button" @click="Getsheet()" class="btn btn-success">get Excel</button>
                <download-excel :data="json_data">
                  <button type="button" class="btn btn-success">Download Excel</button>
                </download-excel>
              </div>
              -->
              <div style="padding:10px">

                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='padding:2px;text-align: center'>الكود</th>
                      <th style='padding:2px;text-align: center'>الاسم</th>
                      <th style='padding:2px;text-align: center'>التاريخ</th>
                      <th style='padding:2px;text-align: center'>1ش</th>
                      <th style='padding:2px;text-align: center'>2ش</th>
                      <th style='padding:2px;text-align: center'>3ش</th>
                      <th style='padding:2px;text-align: center'>4ش</th>
                      <th style='padding:2px;text-align: center'>5ش</th>
                      <th style='padding:2px;text-align: center'>6ش</th>
                      <th style='padding:2px;text-align: center'>7ش</th>
                      <th style='padding:2px;text-align: center'>8ش</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>
                      <td align='center'>{{record.rec_id}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.next_change}}</td>
                      <td align='center' :class="{itemColor:record.item_1}"></td>
                      <td align='center' :class="{itemColor:record.item_2}"></td>
                      <td align='center' :class="{itemColor:record.item_3}"></td>
                      <td align='center' :class="{itemColor:record.item_4}"></td>
                      <td align='center' :class="{itemColor:record.item_5}"></td>
                      <td align='center' :class="{itemColor:record.item_6}"></td>
                      <td align='center' :class="{itemColor:record.item_7}"></td>
                      <td align='center' :class="{itemColor:record.item_8}"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.itemColor {
  background-color: purple !important;
}
.fcolor {
   color: #CC0000;
}
.disabled {
    pointer-events: none;
    cursor: default;
    color: gray;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  name: 'Rep02',
  components: {
    tbDate
  },
  data () {
    return {
      json_data: '',
      today: true,
      fromTitle: 'من تاريخ',
      toTitle: 'الى تاريخ',
      from_date: '',
      to_date: '',
      emptyRec: [{id: 0, name: 0}],
      validationErrors: '',
      region_id: {},
      regions: '',
      records: {},
      lines: {},
      line: '',
      selectedLine: [],
      record: {},
      isLoadingData: false,
      branches: {},
      governorates: {},
      itineraries: {},
      tabName: 'إدراج',
      title: '',
      brancheID: 0,
      itinerarie: 0
    }
  },
  created () {
    this.governorates = JSON.parse(localStorage.getItem('Gov'))
    this.governorates.unshift(this.emptyRec)
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.branch = this.branches[0].id
    this.FillItineraries()
  },
  methods: {
    FillItineraries () {
      this.line = ''
      this.regions = ''
      this.region_id = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
      if (i > -1) {
        this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.line = 0
      }
    },
    FillRegions (e) {
      this.$nextTick(() => {
        var id = (this.selectedLine[0])
        this.regions = ''
        this.region_id = ''
        if (id != null && id.length !== 0) {
          let r = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
          let i = this.branches[r].itineraries.findIndex(x => x.id === parseInt(id))
          if (i > -1) {
            this.regions = JSON.parse(JSON.stringify(this.branches[r].itineraries[i].regions))
            this.regions.unshift(this.emptyRec)
          }
        }
      })
    },
    GetData () {
      let routeData = this.$router.resolve({name: 'Rep01', query: {data: 'someData'}})
      window.open(routeData.href, '_blank')
      this.isLoadingData = true
      this.validationErrors = ''
      axios.post(this.$apiURL + 'get-rep02', {
        token: localStorage.getItem('token'),
        branch_id: this.brancheID,
        from_date: this.from_date,
        to_date: this.to_date,
        region_id: this.region_id,
        selectedLine: this.selectedLine
      })
        .then(res => {
          this.isLoadingData = false
          this.records = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    // ===================================================
    Getsheet () {
      axios.post(this.$apiURL + 'get-sheet', {
        token: localStorage.getItem('token')
      })
        .then(res => {
          this.json_data = res.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/Rep02.vue